export const FETCH_PINCODES='FETCH_PINCODES';
export const ADD_PRODUCTS="ADD_PRODUCTS";
export const ADD_TO_CART="ADD_TO_CART";
export const CLEAR_CART="CLEAR_CART";
export const UPDATE_CART="UPDATE_CART";
export const UPDATE_TOTAL="UPDATE_TOTAL";
export const CLEAR_TOTAL="CLEAR_TOTAL";
export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGIN="LOGIN";
export const LOGIN_ERROR="LOGIN_ERROR";
export const LOGOUT="LOGOUT";
export const LOGIN_REQ="LOGIN_REQ";
export const SIGNUP="SIGNUP";
export const SIGNUP_ERROR="SIGNUP_ERROR";
export const FETCH_ORDER="FETCH_ORDER";
export const ADD_ORDER="FETCH_ORDER";
export const FETCH_SINGLE_ORDER="FETCH_SINGLE_ORDER";
export const LOGIN_WITH_GOOGLE="LOGIN_WITH_GOOGLE";
export const FETCH_PRODUCT_BY_ID="FETCH_PRODUCT_BY_ID";
export const REMOVE_FROM_CART="REMOVE_FROM_CART";
export const FETCH_ADDRESS="FETCH_ADDRESS";
export const EDIT_ADDRESS="EDIT_ADDRESS";
export const TOP_LOADING_CHANGE="TOP_LOADING_CHANGE";
export const RAZOR_ORDER_CREATION="RAZOR_ORDER_CREATION";
export const RAZOR_KEY="RAZOR_KEY";
export const RAZOR_PLACE_ORDER="RAZOR_PLACE_ORDER";
export const ORDERID_CHANGE="ORDERID_CHANGE";
export const REFRESH_ACCESS_TOKEN="REFRESH_ACCESS_TOKEN";
export const REFRESH_TOKEN="REFRESH_TOKEN";
export const ORDER_SUCCESS="ORDER_SUCCESS";
export const ORDER_FAILED="ORDER_FAILED";
export const REFRESH_TOKEN_EXPIRED="REFRESH_TOKEN_EXPIRED";
export const REFRESH_TOKEN_PRESENT="REFRESH_TOKEN_PRESENT";
export const MODAL_TRIGGER="MODAL_TRIGGER";